/** @type {import('tailwindcss').Config} */

import defaultTheme from 'tailwindcss/defaultTheme';

export const preset = {
  content: ['./src/**/*.{astro,html,js,jsx,md,mdx,svelte,ts,tsx,vue}'],
  theme: {
    extend: {
      screens: {
        sm: '640px',
        // => @media (min-width: 640px) { ... }

        md: '768px',
        // => @media (min-width: 768px) { ... }

        lg: '1024px',
        // => @media (min-width: 1024px) { ... }

        xl: '1280px',
        // => @media (min-width: 1280px) { ... }

        '2xl': '1536px',
        // => @media (min-width: 1536px) { ... }
      },
      fontFamily: {
        sans: ['diatype', ...defaultTheme.fontFamily.sans],
        serif: ['recife', ...defaultTheme.fontFamily.serif],
        mono: ['diatypemono', ...defaultTheme.fontFamily.mono],
      },
      colors: {
        blue: {
          300: '#93B7F0',
          400: '#6F9FEB',
          500: '#4B88E6',
          600: '#3C6CB8',
          700: '#2D518A',
        },
        green: {
          300: '#BFEEDE',
          400: '#54D2A9',
          500: '#2AC794',
          600: '#219F76',
          700: '#197758',
        },
        purple: {
          300: '#9084A3',
          400: '#6B5B84',
          500: '#473366',
          600: '#382851',
          700: '#2A1E3D',
        },
        cream: {
          300: '#FDFCFB',
          400: '#FAF7F3',
          500: '#F7F2EB',
          600: '#DDD9D3',
          700: '#C5C1BC',
        },
        red: {
          200: 'rgba(255,0,0,0.06)',
          300: '#FFD4D4',
          400: '#FF8282',
          500: '#FF0000',
          600: '#CC0000',
          700: '#990000',
        },
        orange: {
          300: '#FFCC77',
          400: '#FFAA55',
          500: '#FF8833',
          600: '#D9742B',
          700: '#99521F',
        },
        gray: {
          300: '#F5F5F5',
          400: '#E5E5E5',
          500: '#CBCBCB',
          600: '#B2B2B2',
          700: '#7F7F7F',
        },
        alpha: {
          300: 'rgba(0, 0, 0, 0.06)',
          400: 'rgba(0, 0, 0, 0.1)',
          500: 'rgba(0, 0, 0, 0.16)',
          600: 'rgba(0, 0, 0, 0.24)',
          700: 'rgba(0, 0, 0, 0.40)',
        },
        black: {
          300: '#9E9E9E',
          400: '#616161',
          500: '#212121',
          900: '#000000',
        },
        morton: {
          900: '#101552',
          800: '#1A2470',
          700: '#26368A',
          600: '#3752B3',
          500: '#5C78C7',
          400: '#89A0D2',
          300: '#BBCAE2',
          200: '#DCE4EF',
          100: '#E6ECF4',
          50: '#F4F7FA',
          30: '#F8FAFC',
        },
        hardwood: {
          900: '#2B211A',
          800: '#423429',
          700: '#544336',
          600: '#6A5A4D',
          500: '#887363',
          400: '#AE9989',
          300: '#D3C5BB',
          200: '#E8E0DB',
          100: '#F2EAE3',
          50: '#FCF6F0',
          30: '#FEFBF6',
        },
        fireplace: {
          900: '#501007',
          800: '#701A0B',
          700: '#972812',
          600: '#C13C1A',
          500: '#DE5930',
          400: '#EF8C61',
          300: '#FAB894',
          200: '#FFE0CC',
          100: '#FFE8D6',
          50: '#FFF4EB',
          30: '#FFFAF5',
        },
        sunroom: {
          900: '#613B19',
          800: '#784A1C',
          700: '#8F5E1E',
          600: '#B0721C',
          500: '#D48816',
          400: '#F2A218',
          300: '#FCB833',
          200: '#FED876',
          100: '#FFE89E',
          50: '#FFF7DB',
          30: '#FFFDF5',
        },
        yard: {
          900: '#1D3F2B',
          800: '#244D2D',
          700: '#2A5A2B',
          600: '#4A7939',
          500: '#759948',
          400: '#9BBE60',
          300: '#BFD58B',
          200: '#DEE9B9',
          100: '#EEF4D7',
          50: '#F7FAEA',
          30: '#FCFDF7',
        },
        pool: {
          900: '#002E2C',
          800: '#00413F',
          700: '#075553',
          600: '#13716E',
          500: '#299490',
          400: '#44BBB5',
          300: '#90D5D1',
          200: '#C4E3E2',
          100: '#DEEDEC',
          30: '#F8FBFB',
          50: '#EBF4F4',
        },
        sidewalk: {
          900: '#212121',
          800: '#303030',
          700: '#474747',
          600: '#616161',
          500: '#707070',
          400: '#7F7F7F',
          300: '#999999',
          200: '#B2B2B2',
          100: '#CBCBCB',
          50: '#E5E5E5',
          30: '#F5F5F5',
        },
        hydrant: {
          900: '#4D0000',
          800: '#700000',
          700: '#990000',
          600: '#CC0000',
          500: '#FF0000',
          400: '#FF8282',
          300: '#FFADAD',
          200: '#FFD4D4',
          100: '#FFE0E0',
          50: '#FFF0F0',
          30: '#FFFAFA',
        },
        autumn: {
          900: '#3C200C',
          800: '#5E3213',
          700: '#99521F',
          600: '#D9742B',
          500: '#FF8833',
          400: '#FFAA55',
          300: '#FFBF6B',
          200: '#FFD284',
          100: '#FFE4AD',
          30: '#FFFAF0',
          50: '#FFF1D6',
        },
        gravel: {
          30: '#F8F7F6',
          50: '#F2F0EE',
          70: '#E9E8E7',
        },
      },
    },
  },
};
